import type { Ref } from 'vue';

import { onScopeDispose, ref } from 'vue';

export interface UseWindowScrollingReturn {
	isScrolling: Ref<boolean>;
	y: Ref<number>;
}

const MIN_SUSTAINED_MS = 8;

// Detector leve do scroll do documento: expõe `isScrolling` (com debounce de
// ociosidade) e a posição vertical `y`.
//
// Diferente de `useScroll`/`useWindowScroll` do VueUse, este NÃO lê geometria
// que força reflow (scrollHeight/offsetHeight/getBoundingClientRect) a cada
// evento — aquelas leituras causam layout thrashing durante o fling. Ler
// `window.scrollY` é apenas a posição de scroll (barato, não força layout).
export function useWindowScrolling(idleMs = 150): UseWindowScrollingReturn {
	const isScrolling = ref(false);
	const y = ref(0);

	if (!import.meta.client) return { isScrolling, y };

	y.value = window.scrollY;

	let idleTimer: number | undefined;
	let sessionStartedAt: number | null = null;

	function handleScroll(): void {
		y.value = window.scrollY;

		const now = Date.now();
		if (sessionStartedAt === null) {
			sessionStartedAt = now;
		} else if (now - sessionStartedAt >= MIN_SUSTAINED_MS) {
			isScrolling.value = true;
		}

		if (idleTimer !== undefined) clearTimeout(idleTimer);
		idleTimer = window.setTimeout(() => {
			isScrolling.value = false;
			sessionStartedAt = null;
		}, idleMs);
	}

	window.addEventListener('scroll', handleScroll, { passive: true });

	onScopeDispose(() => {
		window.removeEventListener('scroll', handleScroll);
		if (idleTimer !== undefined) clearTimeout(idleTimer);
	});

	return { isScrolling, y };
}
